import { ApprovalStatus } from "../../../../types/approval-status/approval-status.type";
import { StatusMarker } from "../../../statusMarker";
import React from "react";

export const StatusChip = (status: ApprovalStatus) => {
  return <StatusMarker status={status} />;
};
